import { useState } from 'react';

/**
 * Shared hook for popover open/close state and search input.
 *
 * @returns Anchor element, open state, search value, and handlers.
 */
export function usePopoverSearch() {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [search, setSearch] = useState('');

	const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(e.currentTarget);
		setSearch('');
	};

	const handleClose = () => {
		setAnchorEl(null);
		setSearch('');
	};

	return { anchorEl, isOpen: anchorEl !== null, search, setSearch, handleOpen, handleClose };
}
